/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from 'react-query';
import BigNumber from 'bignumber.js';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { isMobile } from 'react-device-detect';
import { currencies, exchange, MAXIMUM_LINKED_WALLETS } from '../../../../utilities/constants';
import { RATES_QUERY_KEY, USER_PREFERENCES } from '../../../../utilities/sharedQueries';
import { alphaSort } from '../../../../utilities/helpers';
import { formatNumber } from '../../../../utilities/formatHelpers';
import WalletCard from './walletCard';
import { CARD_UPDATE_LINKED_WALLETS } from '../../mutations';
import { CARD_LINKED_WALLETS } from '../../queries';
import { showAlert } from '../../../../utilities/notifications';
import { TransactionItemPlaceholder } from '../../../../components/Placeholders';

const Wallets = ({ wallets, ledgerAccounts, fiatCurrencyCode, onAddFundsClick }) => {
  const { t: translate } = useTranslation();
  const [sortingOptions, setSortingOptions] = useState({
    ascending: false,
    columnKey: 'priority',
    castToNumber: true,
  });

  const { data: userPref } = useQuery(USER_PREFERENCES);
  const { data: rates } = useQuery(RATES_QUERY_KEY);

  const { refetch: refetchAllWallets, isLoading: isLoadingWallets } = useQuery(CARD_LINKED_WALLETS);

  const isLoading = isLoadingWallets;

  const userFiatCurrencyCode = fiatCurrencyCode || userPref?.displayCurrency || 'EUR';

  const handleSortWallets = (columnName, castToNumber = true) => {
    if (columnName === sortingOptions.columnKey) {
      setSortingOptions((prev) => ({
        ...prev,
        castToNumber,
        ascending: !prev.ascending,
      }));
    } else {
      setSortingOptions({
        castToNumber,
        columnKey: columnName,
        ascending: true,
      });
    }
  };

  const renderedWallets = useMemo(
    () =>
      wallets && wallets.length > 0
        ? wallets.map((wallet) => {
            const currencyIconUpperCase = wallet.coin.toUpperCase();
            const currency = currencies[currencyIconUpperCase];
            const _source = currency.icon;
            const _destination = userFiatCurrencyCode.toUpperCase();
            let _rate = 0;
            let _changes = 0;
            if (rates) {
              if (_source === _destination) {
                _rate = 1;
                _changes = 0;
              } else if (rates[`${_source}${_destination}`]) {
                _rate = new BigNumber(rates[`${_source}${_destination}`].ask);
                _changes = new BigNumber(rates[`${_source}${_destination}`].pctChange1d);
              } else if (rates[`${_destination}${_source}`]) {
                _rate = new BigNumber(1).dividedBy(rates[`${_destination}${_source}`].ask);
                _changes = 0;
              }
            }

            wallet.rate = _rate;
            wallet.change = _changes;
            wallet.currency = currency;

            const walletBalance = formatNumber(
              wallet.available_balance * currency.conversion,
              currency.decimal
            );
            wallet.fiat_balance = parseFloat(
              formatNumber(wallet.rate * walletBalance, exchange.FIAT_VALUE)
            );

            return wallet;
          })
        : [],
    [userFiatCurrencyCode, rates, wallets]
  );

  const [sortedWallet, setSortedWallet] = useState(renderedWallets);

  const sortLabels = useMemo(() => {
    const walletsRemainingLabel = translate('wallets_remaining_label', {
      count: MAXIMUM_LINKED_WALLETS - sortedWallet.length,
    });
    if (isMobile) {
      return [
        {
          id: 0,
          title: walletsRemainingLabel,
          withIcon: false,
        },
      ];
    }
    return [
      {
        id: 0,
        title: walletsRemainingLabel,
        withIcon: false,
      },
      {
        id: 1,
        title: translate('available_balance_label'),
        onClick: () => handleSortWallets('fiat_balance', false),
        withIcon: true,
      },
      {
        id: 4,
        title: translate('actions_label'),
        withIcon: false,
        isRight: true,
      },
    ];
  }, [sortedWallet]);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const { mutate: updateLinkedWallets } = useMutation(CARD_UPDATE_LINKED_WALLETS, {
    onSettled: (_, error) => {
      if (error) {
        showAlert({ message: error.message, type: 'danger' });
      } else {
        refetchAllWallets();
      }
    },
  });

  const onDragEnd = (result) => {
    if (!result.destination) {
      return null;
    }

    const newOrderedWallets = reorder(sortedWallet, result.source.index, result.destination.index);
    updateLinkedWallets({
      walletsIds: newOrderedWallets.map((wallet) => wallet.address_id),
    });

    setSortedWallet(newOrderedWallets);
  };

  useEffect(() => {
    const comparerFn = (a, b) =>
      alphaSort(
        a,
        b,
        sortingOptions.columnKey,
        sortingOptions.ascending,
        sortingOptions.castToNumber
      );
    const _sortedWallets = renderedWallets.sort(comparerFn);
    setSortedWallet([..._sortedWallets]);
  }, [sortingOptions, renderedWallets]);

  return (
    <div>
      <div className="row mx-0 px-0">
        {sortLabels.map((item, index) => (
          <span
            key={item.id}
            className={`text-shadow text-f6 text-start text-nowrap flex-even d-flex align-items-center ${
              item.id === 1 && 'ms-1 pe-0'
            } ${item.id === 2 && 'px-0'} px-0`}
            role={item.onClick ? 'button' : 'none'}
            tabIndex={-1}
            onClick={item.onClick}
            onKeyDown={item.onClick}>
            <span className={`${item.isRight ? 'ms-auto' : ''}`}>
              {item.withIcon && (
                <img
                  alt="sort"
                  src="./assets/images/sort.svg"
                  className="me-1"
                  style={{ width: '1rem', height: '1rem' }}
                />
              )}
              {index === 0 ? <b>{item.title}</b> : <span>{item.title}</span>}
            </span>
          </span>
        ))}
      </div>
      <div
        className={`${isMobile ?? 'w-100 h-65vh'}  overflow-auto pe-3`}
        style={{ width: 'calc(100% + 1rem)' }}>
        {isLoading ? (
          <div className="mt-3">
            <TransactionItemPlaceholder />
            <TransactionItemPlaceholder />
            <TransactionItemPlaceholder />
            <TransactionItemPlaceholder />
          </div>
        ) : (
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <div
                  className="flex flex-column w-100"
                  {...provided.droppableProps}
                  ref={provided.innerRef}>
                  {sortedWallet.map((wallet, index) => (
                    <WalletCard
                      key={wallet.id}
                      wallet={wallet}
                      index={index}
                      fiatCurrencyCode={fiatCurrencyCode}
                      onAddFundsClick={() => onAddFundsClick(wallet, ledgerAccounts[wallet.coin])}
                    />
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        )}
      </div>
    </div>
  );
};

export default Wallets;

Wallets.propTypes = {
  wallets: PropTypes.array,
  onAddFundsClick: PropTypes.func.isRequired,
  ledgerAccounts: PropTypes.object.isRequired,
  fiatCurrencyCode: PropTypes.string,
};
Wallets.defaultProps = {
  wallets: null,
  fiatCurrencyCode: null,
};
